export enum BusinessListName {
  businessType = 'businessType',
  businessCategory = 'businessCategory',
}

export const AppListNames = [
  { id: BusinessListName.businessType, name: BusinessListName.businessType },
  { id: BusinessListName.businessCategory, name: BusinessListName.businessCategory },
]